import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { NotFound } from '@/pages/NotFound';

/**
 * Registro de prototipos disponibles, indexado por slug de la app.
 * Añadir una nueva maqueta = una entrada aquí + su componente en components/mockups/.
 */
// Vacío desde que Action Flow sustituyó al prototipo «Seguimiento de clientes»
// (seed 2f8f197dfb11 + retirada deef7968e576). El mecanismo se conserva.
const MOCKUPS: Record<string, ComponentType> = {};

export function Preview() {
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string }>();
  const Mockup = slug ? MOCKUPS[slug] : undefined;

  if (!Mockup) {
    return <NotFound />;
  }

  return (
    <section aria-labelledby="preview-title" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Link
          to="/"
          className="text-sm font-medium text-appsol-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-appsol-500"
        >
          ← {t('preview.back')}
        </Link>
        <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-800">
          {t('preview.badge')}
        </span>
      </div>

      <p
        role="note"
        className="rounded-md border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900"
      >
        {t('preview.disclaimer')}
      </p>

      <Mockup />
    </section>
  );
}
